import { z } from 'zod';

export const notificationSchema = z.object({
  id: z.string(),
  readAt: z.date().nullable(),
  postId: z.string(),
  clientId: z.string(),
  activityLogId: z.string(),
  agencyId: z.string(),
  userId: z.string().nullable(),
  actorId: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type NotificationSchema = z.infer<typeof notificationSchema>;
